const usePriceHistory = (product, variant) => {
  return variant?.history || product?.history || [];
};

export default usePriceHistory;
